/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 01/06/2020
 *
 */

import React from 'react';
import './errorCodes.css';
import Icon from "../../generic/icon/Icon";

/** functional component for ErrorCodes **/
const ErrorCodes = (props) => {
    // the model
    let model = null;

    // redirection
    const redirectHome = () => {
        props.history.push('/home');
    };

    // code number
    let code = null;

    switch (code) {
        case '401':
            model =
                <div role="main" className="error-landing-page">
                    <div style={{textAlign: 'center'}} className="error-icon">
                        <Icon name="401" />
                    </div>

                    <h1> 401 Unauthorized.</h1>
                    <p> We can't find the page you're looking for.</p>
                    <button onClick={redirectHome}>Back to home</button>
                </div>;
        break;
        case '404':
            model =
                <div role="main" className="error-landing-page">
                    <div style={{textAlign: 'center'}} className="error-icon">
                        <Icon name="401" />
                    </div>

                    <h1> 404 Not Found.</h1>
                    <p> We can't find the page you're looking for.</p>
                    <button onClick={redirectHome}>Back to home</button>
                </div>;
            break;
        default:
            model =
                <div role="main" className="error-landing-page">
                    <div style={{textAlign: 'center'}} className="error-icon">
                        <Icon name="error" />
                    </div>

                    <h1>Error !!!</h1>
                    <p> We can't find the page you're looking for.</p>
                    <button onClick={redirectHome}>Back to home</button>
                </div>;
    }
    return(
        <div className="error-wrapper">
            {model}
        </div>
    );
};

export default ErrorCodes;
